import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { string, func, array, object, bool } from 'prop-types';
import { Modal, Upload } from 'antd';
import { withApollo } from 'react-apollo';
import { replace, get, map, omitBy, isEmpty, head, includes, isNil, size, find } from 'lodash';
import { FlexContainer, Row, Column, Button, FormInput, FormSelect, HasPermissions, Drawer, Icon, Text, If } from '../../common';
import { onlyNumbers } from '../../../utils/Regex';
import NewSectorPicking from './NewSectorPicking';
import { importBodyResolver } from '../../utils/importFeedback';
import { getAccessToken } from '../../../utils/awsAuth';
import { publicRuntimeConfig } from 'config';
import GET_SECTOR_PICKING from '../../graphql/getSectorPicking';
import { Mutation } from '../../graphql';
import MUTATION_EXPORT_DARKSTORE_REPORT from '../../graphql/exportDarkstoreReport';
import PubSub from '../../../services/PubSub';
import { hasPermissionByResource } from '../../../utils/misc';

const IMPORT_DARKSTORE_POSITIONS_URL = `${String(publicRuntimeConfig.GRAPHQL_URL).replace(/\/$/, '')}/import-darkstore-positions`;

const SpaceBetween = styled.div`
    width: ${({ width }) => width};
`;

const ImportDropZone = styled.div`
    width: 100%;
    margin-top: 4px;

    .ant-upload.ant-upload-drag {
        border: 2px dashed #c5e09a;
        border-radius: 8px;
        background: #fff;
        padding: 8px 0;
    }

    .ant-upload.ant-upload-drag:hover,
    .ant-upload.ant-upload-drag.ant-upload-drag-hover {
        border-color: #8cc63f;
        background: #f4ffe8;
    }

    .ant-upload.ant-upload-drag .ant-upload-btn {
        padding: 24px 16px;
    }

    .ant-upload-drag-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
`;

const ImportHint = styled.p`
    margin: 0 0 20px;
    font-size: 13px;
    color: #666;
    line-height: 1.4;
    text-align: left;
    width: 100%;
`;

const ImportTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 6px;
    width: 100%;
    text-align: left;
`;

const DropZoneLabel = styled.div`
    margin-top: 8px;
    font-size: 13px;
    color: #888;
    line-height: 1.4;

    span {
        color: #8cc63f;
        font-weight: 500;
    }
`;

const SelectedFileName = styled.div`
    margin-top: 10px;
    font-size: 12px;
    color: #8cc63f;
`;

const ImportResultBody = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
    padding: 4px 0 8px;

    .import-result-title {
        margin: 8px 0 4px;
    }

    .import-result-subtitle {
        margin: 0;
        font-size: 13px;
        color: #666;
        line-height: 1.4;
        max-width: 320px;
    }
`;

const ContainerWrapper = ({ children, fullWidth, ...more }) => (
    <FlexContainer
        border='2px solid #eaeaea'
        paddingHorizontal={13}
        paddingVertical={3}
        align='center'
        direction={fullWidth ? 'column' : 'row'}
        flex={1}
        display={fullWidth ? 'block' : 'flex'}
        {...more}
    >
        { children }
    </FlexContainer>
);

const Filters = ({ currentValue, onSubmit, salesChannelOptions, client, initialSaleChannelSelected, showMsgSelectFilter, email, setLoading, disableTrash, setDisableTrash, resetCurrentPage, session }) => {
    const [opened, setOpened] = useState(false);
    const [salesChannelSelected, setSalesChannel] = useState(initialSaleChannelSelected);
    const [sectorPickingSelected, setSectorPickingSelected] = useState(null);
    const [numqr, setNumQR] = useState(null);
    const [tray, setTray] = useState(null);
    const [sku, setSku] = useState(null);
    const [ean, setEan] = useState(null);
    const [position, setPosition] = useState(null);
    const [place, setPlace] = useState(null);
    const [sectorPickingOptions, setSectorPickingOptions] = useState(null);
    const [sectorsPickingData, setSectorsPickingData] = useState(null);
    const fullWidth = currentValue === '100%';
    const spaceBetweenWidth = fullWidth ? '0px' : '13px';
    const [showModal, setShowModal] = useState(false);
    const [reloadingFilters, setReloadingFilters] = useState(false);
    const [showImportModal, setShowImportModal] = useState(false);
    const [importFile, setImportFile] = useState(null);
    const [importSalesChannel, setImportSalesChannel] = useState(initialSaleChannelSelected);
    const [importLoading, setImportLoading] = useState(false);
    const [importResult, setImportResult] = useState(null);

    const buttomsContainerProps = !fullWidth ? { mL: 15, pL: 15, fitHeight: true, borderLeft: '1px solid #eaeaea', noFlex: true } : {};

    useEffect(() => {
        getSectorPicking();
    }, []);

    const onPressEnter = ({ key }) => {
        if (key === 'Enter') return onSubmit(cleanFiltersNull());
    };

    useEffect(() => {
        PubSub.dispatch('SET_RIGHT_HEADER', () => rightHeader());
    }, [salesChannelOptions, salesChannelSelected]);

    const rightHeader = () => {
        return (
            <FlexContainer direction='row'>
                <HasPermissions to={['darkstore-page:export']}>
                    <Button width={100} text='Exportar' secondary onClick={() => setShowModal(true)} disabled={showMsgSelectFilter} />
                </HasPermissions>
                {/* TEMP prueba local — el gate real es 'darkstore-page:import' (falta crearlo en roles). REVERTIR antes de commitear. */}
                <HasPermissions to={['darkstore-page:export']}>
                    <Button width={100} text='Importar' onClick={() => setShowImportModal(true)} style={{ marginLeft: 10 }} />
                </HasPermissions>
            </FlexContainer>
        );
    };


    useEffect(() => {
        return () => {
            PubSub.dispatch('SET_RIGHT_HEADER', () => null);
        }
    }, [])

    const ModalBodyComponent = ({ icon, firstLine, secondLine }) => (
        <>
            <Icon name={icon} color='#1fa02e' size={80} bottom={20} />
            <Text text={firstLine} strong size={16} />
            { secondLine && <Text text={secondLine} /> }
        </>
    );

    const modalBodyResolver = (status) => {
        switch (status) {
            case '400':
                return { icon: 'notConnection', firstLine: 'Ups, algo falló', secondLine: 'Por favor vuelve a intentarlo' };
            case '200':
                    return { icon: 'check-mark', firstLine: 'Se exportaron los registros seleccionados', secondLine: 'Serán enviados dentro de unos minutos a tu correo' };
            default:
                return { icon: 'export', firstLine: '¿Está seguro de exportar los datos?' };
        };
    };

    const modal = () => {
        return (
            <Modal
                visible={showModal}
                footer={null}
                closable={false}
                width={400}
                destroyOnClose
                onCancel={() => setShowModal(false)}
            >
                <Mutation mutation={MUTATION_EXPORT_DARKSTORE_REPORT}>
                    {({ data, loading, updateFn }) => {
                        const status = get(data, 'exportDarkstoreReport.internalCode');
                        const successful = includes([status], '200');
                        return (
                            <>
                                <FlexContainer style={{ margin: '30px 0px' }} align='center' direction='column'>
                                    { showModal && <ModalBodyComponent {...modalBodyResolver(status)} /> }
                                </FlexContainer>
                                <FlexContainer justify='center' align='center' style={{ width: '100%' }}>
                                    <Button
                                        link
                                        text={successful ? 'btn.action.close' : 'btn.action.cancel'}
                                        disabled={loading}
                                        style={{ width: '100px', margin: 0 }}
                                        onClick={() => setShowModal(false)}
                                    />
                                    { isNil(status) && <Button
                                        loading={loading}
                                        text={'btn.action.confirm'}
                                        style={{ width: '100px', margin: 0 }}
                                        disabled={loading}
                                        onClick={() => {
                                            updateFn({
                                                variables: {
                                                    filters: cleanFiltersNull(),
                                                    sendToExport: email
                                                }
                                            });
                                        }}
                                    /> }
                                </FlexContainer>
                            </>
                        );
                    }}
                </Mutation>
            </Modal>
        );
    };

    const closeImportModal = () => {
        setShowImportModal(false);
        setImportFile(null);
        setImportResult(null);
        setImportLoading(false);
        setImportSalesChannel(initialSaleChannelSelected);
    };

    const submitImport = async () => {
        const sc = find(get(session, 'salesChannels'), { id: get(head(importSalesChannel), 'value') });
        const form = new FormData();
        form.append('STORE_ID', get(sc, 'store'));
        form.append('COMERCIAL_POLICY', String(get(sc, 'id')));
        form.append('USER_ID', email);
        form.append('file', importFile);

        setImportLoading(true);
        try {
            const token = await getAccessToken();
            const res = await fetch(IMPORT_DARKSTORE_POSITIONS_URL, {
                method: 'POST',
                headers: { Authorization: token ? `Bearer ${token}` : '' },
                body: form
            });
            const data = await res.json().catch(() => ({}));
            setImportResult({
                internalCode: String(get(data, 'internalCode') || res.status),
                message: get(data, 'message') || ''
            });
        } catch (error) {
            setImportResult({ internalCode: '500', message: error.message || 'Error de red' });
        } finally {
            setImportLoading(false);
        }
    };

    const importModal = () => {
        const { internalCode: status, message } = importResult || {};
        if (status) console.log('[import] respuesta back → internalCode:', status, '| message:', message);
        const successful = includes(['200', '201'], status);
        const result = status ? importBodyResolver(status, message) : null;
        return (
            <Modal
                visible={showImportModal}
                footer={null}
                closable={false}
                width={420}
                destroyOnClose
                onCancel={closeImportModal}
                bodyStyle={{ padding: status ? '20px 24px 16px' : '28px 28px 24px' }}
            >
                { isNil(status)
                    ? (
                        <>
                            <ImportTitle>
                                <Icon name='upload-file' color='#8cc63f' size={18} />
                                <Text text='Importar ubicaciones' strong size={16} />
                            </ImportTitle>
                            <ImportHint>
                                Sube un archivo CSV con las ubicaciones a importar. Debe tener las columnas EAN, SKU y AISLE.
                            </ImportHint>
                            <FormSelect
                                label='Local'
                                placeholder='Seleccione un local'
                                options={salesChannelOptions}
                                value={importSalesChannel}
                                disabled={!isEmpty(initialSaleChannelSelected)}
                                onChange={({ value }) => setImportSalesChannel(isEmpty(value) ? [] : [value])}
                            />
                            <ImportDropZone>
                                <Upload.Dragger
                                    accept='.csv'
                                    showUploadList={false}
                                    beforeUpload={(file) => { setImportFile(file); return false; }}
                                >
                                    <Icon name='upload-file' color='#8cc63f' size={32} />
                                    <DropZoneLabel>
                                        Arrastra tu archivo aquí o <span>haz clic para seleccionar</span>
                                    </DropZoneLabel>
                                    { importFile && (
                                        <SelectedFileName>{`✓ ${importFile.name}`}</SelectedFileName>
                                    ) }
                                </Upload.Dragger>
                            </ImportDropZone>
                            <FlexContainer justify='flex-end' align='center' style={{ width: '100%', marginTop: 20 }}>
                                <Button
                                    secondary
                                    text='btn.action.cancel'
                                    disabled={importLoading}
                                    style={{ margin: 0, minWidth: 100 }}
                                    onClick={closeImportModal}
                                />
                                <Button
                                    loading={importLoading}
                                    text='Importar'
                                    style={{ margin: '0 0 0 10px', minWidth: 100 }}
                                    disabled={importLoading || !importFile || isEmpty(importSalesChannel)}
                                    onClick={submitImport}
                                />
                            </FlexContainer>
                        </>
                    )
                    : (
                        <>
                            <ImportResultBody>
                                <Icon
                                    name={result.icon}
                                    color={successful ? '#8cc63f' : '#e53935'}
                                    size={40}
                                />
                                <div className='import-result-title'>
                                    <Text text={result.firstLine} strong size={16} />
                                </div>
                                { result.secondLine && (
                                    <p className='import-result-subtitle'>{result.secondLine}</p>
                                ) }
                            </ImportResultBody>
                            <FlexContainer justify='flex-end' align='center' style={{ width: '100%', marginTop: 12 }}>
                                <Button
                                    text={successful ? 'btn.action.close' : 'btn.action.cancel'}
                                    secondary={!successful}
                                    disabled={importLoading}
                                    style={{ margin: 0, minWidth: 100 }}
                                    onClick={closeImportModal}
                                />
                            </FlexContainer>
                        </>
                    ) }
            </Modal>
        );
    };

    const toggleDrawer = () => setOpened(!opened);

    const cleanFilters = () => {
        const hasInitialSaleChannel = !isEmpty(initialSaleChannelSelected);
        const saleChannelFilter = hasInitialSaleChannel
            ? { comercial_policy: get(head(initialSaleChannelSelected), 'value') }
            : {};
        resetCurrentPage();
        setSalesChannel(hasInitialSaleChannel ? initialSaleChannelSelected : []);
        setSectorPickingSelected([]);
        setNumQR(null);
        setTray(null);
        setSku(null);
        setEan(null);
        setPosition(null);
        setPlace(null);
        onSubmit(saleChannelFilter);
        setReloadingFilters(true);
        setTimeout(() => {
            setReloadingFilters(false)
        }, 50);
    };

    const cleanFiltersNull = () => {
        const filters = {
            comercial_policy: isEmpty(salesChannelSelected) ? map(get(session, 'salesChannels'), 'id') : get(head(salesChannelSelected), 'value'),
            tray,
            numqr,
            sku,
            ean,
            position,
            place,
            sectorPicking: map(sectorPickingSelected, (item) => get(item, 'value'))
        };

        resetCurrentPage();

        return omitBy(filters, (item) => {
            return isEmpty(item);
        });
    };

    const getSectorPicking = async () => {
        client.query({ query: GET_SECTOR_PICKING, fetchPolicy: 'network-only' })
            .then(({ data }) => {
                const payload = get(data, 'getSectorPicking.payload');
                setSectorsPickingData(payload);
                const structureSectorPickingOptions = map(payload, (item) => {
                    return {
                        value: get(item, 'sectorPicking'),
                        label: get(item, 'sectorPicking')
                    };
                });

                setSectorPickingOptions(structureSectorPickingOptions);
            });
    };

    const fieldNumberHandler = (target, callback = () => {}, alphanumeric = false) => callback(replace(get(target, 'value', ''), alphanumeric ? '' : onlyNumbers, ''));

    const fields = [
        [
            {
                label: 'Local',
                options: salesChannelOptions,
                onChange: ({ value }) => isEmpty(initialSaleChannelSelected) && setSalesChannel(isEmpty(value) ? [] : [value]),
                value: salesChannelSelected,
                Component: FormSelect
            },
            {
                label: 'Sector de picking',
                multiple: true,
                value: sectorPickingSelected,
                options: sectorPickingOptions,
                onChange: ({ value }) => setSectorPickingSelected(value),
                Component: props => (
                    <>
                        { !isEmpty(sectorPickingOptions) && <FormSelect {...props} /> }
                    </>
                )
            },
            {
                label: 'Código SAP',
                placeholder: 'Ingrese código SAP',
                maxLength: 15,
                hook: setSku,
                value: sku
            },
            {
                label: 'EAN',
                placeholder: 'Ingrese EAN',
                hook: setEan,
                maxLength: 13,
                value: ean
            }
        ],
        [
            {
                label: 'Ubicación primer nivel',
                placeholder: 'Ingrese ubicación primer nivel',
                hook: setPosition,
                maxLength: 15,
                value: position
            },
            {
                label: 'Ubicación segundo nivel',
                placeholder: 'Ingrese ubicación segundo nivel',
                hook: setPlace,
                maxLength: 10,
                value: place
            },
            {
                label: 'Ubicación tercer nivel',
                placeholder: 'Ingrese ubicación tercer nivel',
                hook: setTray,
                maxLength: 10,
                value: tray
            },
            {
                label: 'QR',
                placeholder: 'Ingrese ID de QR',
                hook: setNumQR,
                maxLength: 18,
                value: numqr,
                alphanumeric: true
            }
        ]
    ];

    const buttons = [
        {
            text: 'Buscar',
            onClick: () => {
                onSubmit(cleanFiltersNull());
                setLoading(true);
            },
            top: 10
        },
        {
            text: 'Limpiar',
            onClick: () => cleanFilters()
        }
    ];

    return (
        <FlexContainer pY={23} direction='column'>
            <If
                condition={!reloadingFilters}
                then={
                    <ContainerWrapper fullWidth={fullWidth}>
                        <Column>
                            { map(fields, row => (
                                <Row noWrap={!fullWidth}>
                                    { map(row, ({ Component = FormInput, hook, alphanumeric, ...props }, index) => {
                                        const aditionalProps = get(props, 'placeholder', null) ? { onKeyPress: onPressEnter, onChange: ({ target }) => fieldNumberHandler(target, hook, alphanumeric) } : {};
                                        return (
                                            <>
                                                <Component
                                                    {...props}
                                                    {...aditionalProps}
                                                />
                                                <If
                                                    condition={size(row) !== index + 1}
                                                    then={<SpaceBetween width={spaceBetweenWidth} />}
                                                />
                                            </>
                                        );
                                    }) }
                                </Row>
                            )) }
                        </Column>
                        <Column {...buttomsContainerProps}>
                            { map(buttons, button => (
                                <Button
                                    bottom={10}
                                    {...button}
                                />
                            )) }
                        </Column>
                    </ContainerWrapper>
                }
            />
            <ContainerWrapper
                fullWidth={fullWidth}
                mT={10}
                paddingVertical={13}
                justify={hasPermissionByResource({ session, to: 'darkstore-page:delete-qr' }) ? 'space-between' : 'flex-end'}
            >
                <HasPermissions to={['darkstore-page:delete-qr']}>
                    <Button
                        link
                        onClick={() => setDisableTrash(!disableTrash)}
                        width={fullWidth ? undefined : 'fit-content'}
                    >
                        <Icon name='trash' size={18} color='#A4C735' />
                        <Text text='&nbsp;Activar/Desactivar' color='#A4C735' strong />
                    </Button>
                </HasPermissions>
                <HasPermissions to={['darkstore-page:create-sector-picking']} >
                    <Button
                        secondary
                        textTransform='uppercase'
                        text='Sector de picking'
                        onClick={() => toggleDrawer()}
                        width={fullWidth ? undefined : 'fit-content'}
                    />
                </HasPermissions>
            </ContainerWrapper>
            <Drawer
                values={['25%', '25%', '100%']}
                visible={opened}
                destroyOnClose
                onClose={toggleDrawer}
                minWidth={330}
            >
                <NewSectorPicking
                    toggleDrawer={toggleDrawer}
                    setOpened={() => setOpened(false)}
                    updateSelectedSectorPicking={() => getSectorPicking()}
                    sectorsPickingData={sectorsPickingData}
                />
            </Drawer>
            { modal() }
            { importModal() }
        </FlexContainer>
    );
};

Filters.propTypes = {
    currentValue: string,
    onSubmit: func,
    salesChannelOptions: array,
    client: object,
    initialSaleChannelSelected: array,
    showMsgSelectFilter: bool,
    email: string,
    setLoading: func,
    session: object,
    resetCurrentPage: func
};

export default withApollo(Filters);
